export const SEARCH_PLACEHOLDER = 'Search columns';
